import { MdErrorOutline } from 'react-icons/md';
import styles from './DebtCard.module.scss';

type Props = {
    title: string;
    // optional second line telling the user what to do
    action?: string;
};

// The red box under a debt card's header: failed files, a wrong-type sanction
// letter, and the missing sanction letter / repayment schedule prompts.
const ErrorBanner = ({ title, action }: Props) => (
    <div className={styles.errorBanner}>
        <div className={styles.errorBannerTitle}>
            <MdErrorOutline className={styles.errorBannerIcon} />
            <div>{title}</div>
        </div>
        {action ? <div className={styles.errorBannerAction}>{action}</div> : null}
    </div>
);

export default ErrorBanner;
